<template>
    <div class="card shadow-sm">
        <img :src="path" :alt="title" class="bd-placeholder-img card-img-top img-fluid" width="100%">

        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <p class="card-text">{{ description }}.</p>
            <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                    <a v-if="'true' == hasVideo" :href="urlVideo" type="button" class="btn btn-sm btn-outline-primary" target="_blank">Video</a>
                    <a v-if="'true' == hasSite" :to="urlSite" type="button" class="btn btn-sm btn-outline-success" target="_blank">Sitio</a>
                </div>
                <small class="text-muted">{{ code }}</small>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            title: String,
            description: String,
            hasVideo: String,
            urlVideo: String,
            hasSite: String,
            urlSite: String,
            path: String,
            code: String
        }
    }
</script>